module.exports = __webpack_public_path__ + "static/media/LHB-USDT.32491419.svg";